import {
    GetComponentProps,
    history,
    request,
    useActions,
    useBook,
    useFile,
    useInPreview,
    useModel,
    useAsyncEffect
} from 'topwrite';
import { useEffect, useMemo } from 'react';
import { EventStreamContentType, fetchEventSource, } from '@fortaine/fetch-event-source';
import { useSubBook } from '@/lib/sub-book';
import path from 'path';

export default function Activate({ children }: GetComponentProps<'activate'>) {

    const { setHandler: setSearchHandler } = useActions('search');
    const { setHandler: setAskHandler } = useActions('ask');
    const { summary } = useBook();
    const preview = useInPreview();
    const subBook = useSubBook();
    const file = useFile();
    const [{ lfs }, { intercept, fetch }] = useModel('page');

    useAsyncEffect(async () => {
        if (!preview) {
            const pathname = location.pathname;
            const dir = pathname.endsWith('/') ? pathname : path.dirname(pathname);
            const base = path.resolve(dir, file.relative('/'));

            try {
                const searchUrl = path.join(base, 'search');
                await request.head(searchUrl);
                setSearchHandler(async (keyword, part) => {
                    try {
                        const { data } = await request.post<any[]>(path.join(base, 'search'), {
                            keyword,
                            part
                        });

                        return data;
                    } catch {
                        return [];
                    }
                });

                const askUrl = path.join(base, 'ask');
                await request.head(askUrl);
                setAskHandler((keyword, part) => {
                    return new Promise((resolve, reject) => {
                        const { readable, writable } = new TransformStream();
                        const reader = readable.getReader();
                        const writer = writable.getWriter();
                        let finished = false;

                        fetchEventSource(askUrl, {
                            method: 'POST',
                            body: JSON.stringify({
                                keyword,
                                part
                            }),
                            headers: {
                                'Content-Type': 'application/json',
                            },
                            async onopen(res) {
                                if (
                                    !res.ok ||
                                    !res.headers
                                        .get('content-type')
                                        ?.startsWith(EventStreamContentType) ||
                                    res.status !== 200
                                ) {
                                    finished = true;
                                    reject();
                                } else {
                                    resolve(reader);
                                }
                            },
                            async onmessage(msg) {
                                if (msg.data === '[DONE]' || finished) {
                                    finished = true;
                                    return;
                                }

                                try {
                                    const text = JSON.parse(msg.data);
                                    await writer.write(text);
                                } catch {

                                }
                            },
                            async onclose() {
                                finished = true;
                                await writer.close();
                            },
                            openWhenHidden: true,
                        });

                    });
                });
            } catch {

            }
        }
    }, []);

    const articleMatch = useMemo(() => {
        const article = summary.getArticle(article => article.getPath() === file.path);

        return article || file.path === 'index.html';
    }, [file]);

    useEffect(() => {
        if (lfs) {
            subBook.setLfsFiles(lfs.files);
        }

        intercept(({ request }) => {
            request.use(subBook.interceptRequest());
        });

        if (articleMatch) {
            if (file.content === undefined) {
                //重新加载
                fetch(history.location.pathname);
            }
        } else {
            const id = subBook.resolveBook(file.path);
            if (id) {
                const article = summary.getArticle(() => {
                    return true;
                }, (part) => part.getMetadata('reference') === id);

                if (article) {
                    history.replace(file.relative(article.path));
                    return;
                }
            }

            //跳转首页
            history.replace(file.relative('/'));
        }
    }, []);

    if (!articleMatch) {
        return null;
    }

    return children;
}
